import React from 'react';

import { SvgProps } from './svg.type';

export const CheckSVG: React.FC<SvgProps> = (props) => (
    <svg
        width="194"
        height="144"
        viewBox="0 0 194 144"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            opacity="0.1"
            d="M23 72L72.3333 121L171 23"
            stroke="url(#paint0_linear_1379:11)"
            strokeWidth="45"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1379:11"
                x1="23.0058"
                y1="72.0215"
                x2="170.995"
                y2="72.0215"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#AAD485" />
                <stop offset="0.02" stopColor="#AAD485" />
                <stop offset="1" stopColor="#6CBE45" />
            </linearGradient>
        </defs>
    </svg>
);
